import { render } from "./AcceptanceConfirmation.vue?vue&type=template&id=5f8efd70"
import script from "./AcceptanceConfirmation.vue?vue&type=script&lang=js"
export * from "./AcceptanceConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__